import { SeoLandingLayout, SeoLandingPageData } from '../../../components/SeoLandingLayout';

const data: SeoLandingPageData = {
  seo: {
    title: 'Cash flow entreprise : comprendre, piloter et optimiser | Trezoone',
    description: 'Le cash flow, c\'est le flux de trésorerie net de votre entreprise. Apprenez à le lire, l\'optimiser et anticiper les tensions avec Trezoone.',
    canonical: '/cash-flow-entreprise',
    keywords: 'cash flow entreprise, flux trésorerie, cash flow négatif, optimiser cash flow, gestion cash flow',
  },
  hero: {
    tag: 'Cash flow entreprise',
    title: 'Cash flow positif ≠ pas de problème. Cash flow négatif ≠ catastrophe.',
    subtitle: 'Le cash flow, c\'est bien plus qu\'un solde de compte. C\'est la mesure de la santé financière réelle de votre activité. Voici comment l\'interpréter et agir dessus.',
    ctaLabel: 'Analyser mon cash flow',
  },
  pilierLink: { label: 'Gestion de trésorerie', href: '/gestion-tresorerie' },
  sections: [
    {
      type: 'explain',
      title: 'Cash flow : les 3 composantes à comprendre',
      content: 'Le cash flow d\'une entreprise se décompose en 3 flux distincts :',
      items: [
        'Cash flow opérationnel : générée par l\'activité courante (ventes - charges)',
        'Cash flow d\'investissement : achats/ventes d\'actifs (machines, locaux, véhicules)',
        'Cash flow de financement : emprunts, remboursements, apports en capital',
        'Cash flow total = somme des 3 → c\'est ce qui explique l\'évolution de votre solde bancaire',
      ],
    },
    {
      type: 'example',
      title: 'Exemple : interpréter un cash flow négatif',
      content: 'Cash flow négatif ne signifie pas toujours problème. Ça dépend de l\'origine.',
      items: [
        'CF opérationnel négatif = votre activité consomme plus de cash qu\'elle n\'en génère → alerte',
        'CF d\'investissement négatif = vous investissez pour grandir → normal si financé',
        'CF de financement négatif = vous remboursez des emprunts → positif à long terme',
        'Analyse de Trezoone : décompose automatiquement votre cash flow par type',
      ],
    },
    {
      type: 'midcta',
      title: 'Cash flow négatif ce mois-ci ? Identifiez la cause en 2 minutes et agissez avant la rupture',
      content: 'Trezoone décompose votre cash flow par type de flux et vous indique précisément d\'où vient la tension.',
    },
    {
      type: 'solution',
      title: 'Piloter son cash flow avec Trezoone',
      content: 'Trezoone catégorise automatiquement vos flux et vous donne une vision claire de votre cash flow.',
      items: [
        'Catégorisation IA des transactions bancaires',
        'Tableau de bord cash flow par catégorie et par mois',
        'Comparaison cash flow prévisionnel vs réalisé',
        'Alerte si le cash flow opérationnel se dégrade',
        'Rapport cash flow pour vos partenaires financiers',
      ],
    },
    {
      type: 'cluster',
      title: 'Tout sur la santé financière de votre entreprise',
      links: [
        { label: 'Gestion de trésorerie', href: '/gestion-tresorerie' },
        { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
        { label: 'BFR et trésorerie', href: '/bfr-tresorerie' },
        { label: 'Prévision trésorerie', href: '/prevision-tresorerie' },
        { label: 'Problème cash flow', href: '/probleme-cash-flow' },
        { label: 'Manque de trésorerie', href: '/manque-tresorerie' },
        { label: 'Suivi trésorerie entreprise', href: '/suivi-tresorerie-entreprise' },
        { label: 'Logiciel trésorerie entreprise', href: '/logiciel-tresorerie-entreprise' },
      ],
    },
    {
      type: 'cta',
      title: 'Analysez votre cash flow maintenant',
      content: 'Essai gratuit 14 jours. Importez vos données, obtenez votre analyse cash flow.',
    },
  ],
  relatedLinks: [
    { label: 'Gestion de trésorerie', href: '/gestion-tresorerie' },
    { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
    { label: 'BFR et trésorerie', href: '/bfr-tresorerie' },
    { label: 'Prévision trésorerie', href: '/prevision-tresorerie' },
    { label: 'Problème cash flow', href: '/probleme-cash-flow' },
    { label: 'Manque de trésorerie', href: '/manque-tresorerie' },
    { label: 'Suivi trésorerie entreprise', href: '/suivi-tresorerie-entreprise' },
    { label: 'Différence trésorerie résultat', href: '/difference-tresorerie-resultat' },
  ],
};

interface Props { onNavigate?: (p: string) => void; onSignIn?: () => void; onSignUp?: () => void; }
export default function CashFlowEntreprisePage({ onNavigate, onSignIn, onSignUp }: Props) {
  return <SeoLandingLayout data={data} onNavigate={onNavigate} onSignIn={onSignIn} onSignUp={onSignUp} />;
}
